const badge = "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border";

function activeBadgeCell(row, activeLabel = "Active", inactiveLabel = "Inactive") {
  const on = String(row?.status) === "1";
  return (
    <span
      className={`${badge} ${on ? "border-emerald-200 bg-emerald-50 text-emerald-900" : "border-gray-200 bg-gray-50 text-gray-600"}`}
    >
      {on ? activeLabel : inactiveLabel}
    </span>
  );
}

export function freightFaqSectionStatusCell(row) {
  return activeBadgeCell(row);
}

export function freightFaqStatusCell(row) {
  return activeBadgeCell(row);
}

export function freightFaqAnswerPreviewCell(row) {
  const text = row?.answer != null ? String(row.answer) : "";
  if (!text) return <span className="text-gray-400">—</span>;
  return (
    <span className="block max-w-md text-sm text-gray-700 line-clamp-2" title={text}>
      {text}
    </span>
  );
}

export const FREIGHT_FAQ_SECTION_COLUMNS = [
  { key: "id", label: "ID", aliases: [], defaultVisible: false },
  { key: "name", label: "Name", aliases: [], defaultVisible: true },
  { key: "order_no", label: "Order", aliases: ["orderNo"], defaultVisible: true },
  {
    key: "status",
    label: "Status",
    aliases: [],
    defaultVisible: true,
    sortable: false,
    renderCell: freightFaqSectionStatusCell
  }
];

export const FREIGHT_FAQ_COLUMNS = [
  { key: "id", label: "ID", aliases: [], defaultVisible: false },
  { key: "section_name", label: "Section", aliases: [], defaultVisible: true },
  { key: "question", label: "Question", aliases: [], defaultVisible: true },
  {
    key: "answer",
    label: "Answer",
    aliases: [],
    defaultVisible: true,
    sortable: false,
    renderCell: freightFaqAnswerPreviewCell
  },
  { key: "order_no", label: "Order", aliases: ["orderNo"], defaultVisible: true },
  {
    key: "status",
    label: "Status",
    aliases: [],
    defaultVisible: true,
    sortable: false,
    renderCell: freightFaqStatusCell
  }
];
